import union from "lodash/union";
import { commentsConstants } from "../constants/comments.constants";

const initialState = {
	emojiHandConstants: [],
	emojiPplConstants: [],
	emojiSymbolConstants: [],
	metricComments: [],
	emojisData:[],
	commentStatus : [],
	commentListRequestedId: null,
	commentListError: false

};

const asId = (value) => (value == null ? null : String(value));

// `commentList` is a single list shared by every consumer of this slice, and a
// request whose popup has already closed still resolves. Once a caller has
// declared which KR it is waiting for (CLEAR_COMMENT_LIST below), a response for
// any other KR is discarded rather than allowed to overwrite that list.
// Callers that never declare one — the KR details page — are unaffected.
const isForAnotherKr = (state, action) =>
	state.commentListRequestedId != null
	&& asId(action.metricId) !== state.commentListRequestedId;

const CommentsReducer = (state = initialState, action) => {
	switch (action.type) {
		case commentsConstants.UPDATE_INITIAL_PROPS:
			return Object.assign(state, action.data);
		case commentsConstants.GET_COMMENT_LIST_SUCCESS:
			if (isForAnotherKr(state, action)) return state;
			let comStatus = {};
			comStatus[action.metricId] = {fetched : true};
			let commentStatus = Object.assign({}, state.commentStatus, comStatus);
			return {
				...state,
				commentList: action.data.goalComments || [],
				commentListError: false,
				emojiHandConstants: action.data.emojiHandConstants,
				emojiPplConstants: action.data.emojiPplConstants,
				emojiSymbolConstants: action.data.emojiSymbolConstants,
				commentStatus
			};
		case commentsConstants.GET_NEW_COMMENT_SUCCESS:
			if (state.commentList && state.commentList.unshift(action.successData)) {
				return {
					...state,
					commentList: state.commentList
				};
			} else {
				state.metricComments[action.successData.metric_id].unshift(action.successData)
				return {
					...state,
					metricComments: state.metricComments
				}
			}
		case commentsConstants.GET_DELETE_COMMENT_SUCCESS:
			if (state.commentList) {
				return {
					...state,
					commentList: state.commentList.filter(data => data.id != action.successData.data)
				};
			} else {
				let filteredComments = state.metricComments[action.successData.metric_id].filter(data => {
					return data.id != action.successData.data
				})
				let metComments = {};
				metComments[action.successData.metric_id] = filteredComments;
				return {
					...state,
					metricComments: Object.assign({}, state.metricComments, metComments)
				}
			}
		case commentsConstants.GET_EDIT_COMMENT_SUCCESS:
			if (state.commentList) {
				state.commentList.forEach((key, index) => {
					if (key.id == action.data.id) state.commentList[index] = action.data
				})
				return {
					...state,
					commentList: state.commentList
				};
			} else {
				state.metricComments[action.data.metric_id].forEach((key, index) => {
					if (key.id == action.data.id) state.metricComments[action.data.metric_id][index] = action.data
				})
				return {
					...state,
					metricComments: state.metricComments
				}
			}
		case commentsConstants.UPDATE_REACTED_EMOJI:
			if (state.commentList) {
				state.commentList.map(comment => {
					if ((action.data.obj_type == 'kr_comment' && comment.id == action.data.obj_id)
						|| (action.data.obj_type == 'kr_data_value' && comment.metric_data_id == action.data.obj_id)
						|| (action.data.obj_type == 'kr_ds_value' && comment.metric_ds_data_id == action.data.obj_id)
						|| (action.data.obj_type == 'kr_survey_value' && comment.survey_data_id == action.data.obj_id)) {
						comment.reacted_emojis = action.data.reacted_emojis;
					}
				});
				return {
					...state,
					commentList: state.commentList
				};
			} else {
				let metId = action.data.metricId || 0;
				state.metricComments[metId].map(comment => {
					if ((action.data.obj_type == 'kr_comment' && comment.id == action.data.obj_id)
						|| (action.data.obj_type == 'kr_data_value' && comment.metric_data_id == action.data.obj_id)
						|| (action.data.obj_type == 'kr_ds_value' && comment.metric_ds_data_id == action.data.obj_id)
						|| (action.data.obj_type == 'kr_survey_value' && comment.survey_data_id == action.data.obj_id)) {
						comment.reacted_emojis = action.data.reacted_emojis;
					}
				});
				return {
					...state,
					metricComments: state.metricComments
				};
			}
		case commentsConstants.OKR_GET_COMMENT_LIST_SUCCESS:
			let metComments = {}
			metComments[action.successData.metric_id] = action.successData.goalComments;
			let metComm = Object.assign({}, state.metricComments, metComments)
			return {
				...state,
				emojiHandConstants: action.successData.emojiHandConstants,
				emojiPplConstants: action.successData.emojiPplConstants,
				emojiSymbolConstants: action.successData.emojiSymbolConstants,
				metricComments: metComm
			};
		case commentsConstants.SET_USER_DATA:
			return{
				...state,
				userData: action.data.userData,
				emojisData:action.data.emojisData,
				user_timezone: action.data.user_timezone
			}
		case commentsConstants.GET_NEW_CONFIDENCE_COMMENT:
			if (state.commentList && state.commentList.unshift(action.data)) {
				return {
					...state,
					commentList: state.commentList
				};
			}
		case commentsConstants.GET_EDIT_CONFIDENCE_COMMENT_SUCCESS:
			if (state.commentList) {
				state.commentList.forEach((key, index) => {
					if (key.id == action.data.id) {
						state.commentList[index] = action.data.comments[0]
					}
				})
				return {
					...state,
					commentList: state.commentList
				};
			} else {
				state.metricComments[action.data.metric_id].forEach((key, index) => {
					if (key.id == action.data.id) state.metricComments[action.data.metric_id][index] = action.data
				})
				return {
					...state,
					metricComments: state.metricComments
				}
			}
		case commentsConstants.CLEAR_COMMENT_LIST:
			// An optional metricId declares which KR the caller is now waiting for,
			// arming the staleness check at the top of this file.
			return {
				...state,
				commentList: [],
				commentListRequestedId: asId(action.metricId),
				commentListError: false
			}
		case commentsConstants.GET_VIEWABLE_METRIC_IDS_SUCCESS:
			return {
				...state,
				viewableMetricIds: union(state.viewableMetricIds, action.successData.viewableMetricIds),
			};
		case commentsConstants.GET_COMMENT_LIST_FAIL:
			if (isForAnotherKr(state, action)) return state;
			// A failure is not an empty list: `commentList` is left alone so
			// consumers keep any cached comments, and `commentListError` tells them
			// to say the load failed rather than that there is nothing to show.
			return {
				...state,
				commentListError: true
			};
		case commentsConstants.GET_DELETE_COMMENT_FAIL:
		case commentsConstants.GET_EDIT_COMMENT_FAIL:
		case commentsConstants.GET_EDIT_CONFIDENCE_COMMENT_FAIL:
		case commentsConstants.GET_NEW_COMMENT_FAIL:
		case commentsConstants.GET_VIEWABLE_METRIC_IDS_FAIL:
		case commentsConstants.OKR_GET_COMMENT_LIST_FAIL:
			return {
				...state,
			};
		default:
			return state;
	}
}

export default CommentsReducer;